import React from 'react'

const IconDownload = ({
  fill = '#E13B30',
  width = 24,
  height = 24,
  style,
  className,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M13 7.44444V9.81482C13 10.1291 12.8595 10.4306 12.6095 10.6529C12.3594 10.8751 12.0203 11 11.6667 11H2.33333C1.97971 11 1.64057 10.8751 1.39052 10.6529C1.14048 10.4306 1 10.1291 1 9.81482V7.44444M3.66667 5.14815L7 8.11111M7 8.11111L10.3333 5.14815M7 8.11111V1"
        stroke={fill}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default IconDownload
